(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sc) {
    if (sc.dataset.dragInit === 'true') return;
    sc.dataset.dragInit = 'true';

    var down = false, startX = 0, startScroll = 0, moved = false;

    var imgs = sc.querySelectorAll('img');

    function markWhenLoaded(img) {
      if (img.complete && img.naturalWidth > 0) { img.classList.add('is-loaded'); return; }
      img.addEventListener('load', function () { img.classList.add('is-loaded'); });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); });
    }

    function preloadRow() {
      for (var k = 0; k < imgs.length; k++) {
        if (imgs[k].loading === 'lazy') imgs[k].loading = 'eager';
      }
    }

    sc.classList.add('js-fade');
    for (var j = 0; j < imgs.length; j++) markWhenLoaded(imgs[j]);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var n = 0; n < entries.length; n++) {
          if (entries[n].isIntersecting) { preloadRow(); io.disconnect(); }
        }
      }, { rootMargin: '400px 0px' });
      io.observe(sc);
    } else {
      preloadRow();
    }

    sc.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = sc.scrollLeft;
      sc.style.scrollSnapType = 'none';
      sc.style.scrollBehavior = 'auto';
      sc.setPointerCapture(e.pointerId);
    });

    sc.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      sc.scrollLeft = startScroll - dx;
    });

    function snapToNearest() {
      var origin = sc.getBoundingClientRect().left;
      var best = null, bestDist = Infinity;
      for (var i = 0; i < sc.children.length; i++) {
        var delta = sc.children[i].getBoundingClientRect().left - origin;
        if (Math.abs(delta) < bestDist) { bestDist = Math.abs(delta); best = delta; }
      }
      if (best !== null && Math.abs(best) > 1) {
        sc.scrollBy({ left: best, behavior: 'smooth' });
      }
    }

    function end(e) {
      if (!down) return;
      down = false;
      sc.style.scrollBehavior = '';
      sc.style.scrollSnapType = '';
      try { sc.releasePointerCapture(e.pointerId); } catch (err) {}
      if (moved) snapToNearest();
    }

    sc.addEventListener('pointerup', end);
    sc.addEventListener('pointercancel', end);
    sc.addEventListener('dragstart', function (e) { if (moved) e.preventDefault(); });
  }

  function initAll() {
    var list = document.querySelectorAll('.card-scroller');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
